import { render, staticRenderFns } from "./DepotUser.vue?vue&type=template&id=b24e3392&"
import script from "./DepotUser.vue?vue&type=script&lang=js&"
export * from "./DepotUser.vue?vue&type=script&lang=js&"
import style0 from "./DepotUser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports